import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { Timer } from './styles';

class SessionTimer extends Component {
  static propTypes = {
    product: PropTypes.string,
    endDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Object)]),
    onTimeExpiry: PropTypes.func,
  };

  constructor(props) {
    super(props);

    const { endDate } = props;

    this.state = {
      endDate: typeof endDate !== 'undefined' ? moment(endDate) : moment().add(5, 'minute'),
      countdown: '00:00',
      isExpired: false,
    };
  }

  componentWillMount() {
    this.tick();

    this.interval = setInterval(() => {
      this.tick();
    }, 1e3);
  }

  componentDidUpdate() {
    const { isExpired } = this.state;
    const { onTimeExpiry } = this.props;

    if (isExpired) {
      clearInterval(this.interval);
      onTimeExpiry();
    }
  };

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  tick = () => {
    const { endDate } = this.state;

    if (!endDate) {
      this.setState({
        countdown: '00:00',
      });
      return false;
    }

    const now = moment();
    const diff = endDate.diff(now);

    if (diff <= 0) {
      this.setState({
        countdown: '00:00',
        isExpired: true,
      });
      return false;
    }

    const countdown = moment(diff).format('mm:ss');

    return this.setState({
      countdown,
      isExpired: false,
    });
  };

  render() {
    const { countdown } = this.state;
    const { product } = this.props;
    return (
      <Timer>
        Your {product} will be held for <span>{countdown}</span>
      </Timer>
    );
  }
}

export default SessionTimer;
